// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cc-submit {
  padding: 54px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}
.cc-submit span {
  font-weight: 700;
}
.cc-submit {
  height: calc(100vh - 211px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/creditCardSuccess/creditCardSuccess.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".cc-submit {\n  padding: 54px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n}\n.cc-submit span {\n  font-weight: 700;\n}\n.cc-submit {\n  height: calc(100vh - 211px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
